<template>
  <!-- 拼团特惠 -->
  <section class="group-buy">
    <TitleGroup title="拼团特惠" :url="isGroup ? '/package-list?group_buy_list=1': ''"></TitleGroup>
    <swiper :options="swiperOption" :not-next-tick="notNextTick" ref="mySwiper">
      <!--数据请求完成前，先展示默认数据（骨架）-->
      <swiperSlide class="loading" v-for="(item, inx) in defaultList" v-if="!loadDone" :key="inx">
        <div class="item-pic">
          <img v-if="item.p_img_big" :src="cosPrefix + item.p_img_big" :onerror="defaultLogo" />
        </div>
        <div class="item-name">测试</div>
        <div class="item-price">
          <span class="cost">¥2343</span>
        </div>
      </swiperSlide>
      <!--数据请求完成后，展示请求的数据-->
      <swiperSlide
        v-for="(item, index) in list"
        v-if="loadDone"
        @click.native="toPackage($event, item)"
        :key="index"
      >
        <i class="icon icon-shiyushou" v-if="item.activityType === 'saveLife'"></i>
        <div class="item-pic">
          <img :src="cosPrefix + item.p_img_small" :onerror="defaultLogo" />
        </div>
        <div class="item-name">{{ item.subname || item.package_name }}</div>
        <div class="item-price">
          <i>{{item.group_buy_settings.group_size}}人团</i>
          <span class="price">¥{{item.group_buy_settings.sale_price/100}}</span>
          <span class="cost">¥{{item.group_buy_settings.original_price/100}}</span>
        </div>
      </swiperSlide>
    </swiper>
  </section>
</template>

<script>
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper' // swiper组件
import TitleGroup from '@/components/index/TitleGroup' // 标题组组件
import {
  mapGetters
} from 'vuex'
import {
  packageMixin
} from '@/mixins'

require('swiper/dist/css/swiper.css')

export default {
  name: 'group-buy',
  components: {
    TitleGroup,
    swiper,
    swiperSlide
  },
  mixins: [packageMixin],
  props: {
    // 套餐列表
    list: {
      type: Array,
      default () {
        return () => []
      }
    },
    // 套餐列表是否已加载完成
    loadDone: {
      type: Boolean,
      default: false
    },
    // 是否有更多拼团
    isGroup: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultLogo: `this.src="${require('@/assets/images/default-logo-7.png')}"`, // 套餐图片显示错误时展示的默认图片
      cosPrefix: cos_prefix, // 图片资源前缀
      defaultList: [{}, {}, {}], // 默认列表，用于数据请求完成前展示骨架
      notNextTick: true,
      swiperOption: {
        autoplay: false,
        autoHeight: true,
        freeMode: true,
        slidesPerView: 'auto'
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    // 点击套餐列表中的套餐时
    toPackage (e, item) {
      let target = $(e.target).hasClass('swiper-slide')
        ? $(e.target)
        : $(e.target).parents('.swiper-slide')
      target.addClass('down')
      setTimeout(() => {
        target.removeClass('down')
        this.linkPackage(item)
      }, 100)
    }
  },
  watch: {
    // 页面更新时，重置swiper
    $route (to) {
      if (to.name === 'index') {
        setTimeout(() => {
          this.swiper.update()
        }, 500)
      }
    },
    // 数据更新时，重置swiper
    list () {
      setTimeout(() => {
        this.swiper.update()
      }, 500)
    }
  }
}
</script>

<style lang="less" scoped>
@image: '../../assets/images/';

.group-buy {
  background-color: #fff;

  .swiper-container {
    padding: 0 30/200rem 30/200rem;
  }

  .swiper-slide {
    width: 300/200rem;
    margin-right: 20/200rem;
    transition: all 0.05s;

    &:last-child {
      margin-right: 0;
    }

    &.down {
      opacity: 0.75;
    }

    &.loading {
      * {
        color: transparent !important;
      }

      .item-pic,
      .item-name,
      .item-price {
        background-color: rgba(0, 0, 0, 0.05) !important;
      }
    }

    .icon-shiyushou {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      width: 90/200rem;
      height: 90/200rem;
      background-image: url('@{image}/shiyushou/i-coupon-2.png');
      background-size: 100% 100%;
    }

    .item-pic {
      position: relative;
      width: 300/200rem;
      height: 225/200rem;
      border-radius: 10/200rem;
      overflow: hidden;
      border: 1px solid #dedede;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }

    .item-price {
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      & > i {
        padding: 0 4/100rem;
        flex: 0 0 auto;
        background: linear-gradient(180deg, #ff863e 0%, #ff4443 100%);
        box-shadow: 0px 1px 2/100rem 0px rgba(255, 69, 67, 0.1);
        border-radius: 2/100rem;
        font-size: 11/100rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 14/100rem;
        text-align: center;
      }

      .price {
        font-size: 16/100rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ff716a;
        line-height: 22/100rem;
        margin: 0 5/100rem;
      }

      .cost {
        font-size: 10/100rem;
        font-weight: 300;
        color: #666666;
        line-height: 14/100rem;
        text-decoration: line-through;
      }
    }

    .item-name {
      width: 100%;
      margin: 20/200rem 0 10/200rem;
      line-height: 1.2;
      font-size: 28/200rem;
      font-weight: 500;
      color: rgba(46, 46, 46, 1);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
